module.exports = __webpack_public_path__ + "static/media/magnat.b1edf4f7.avif";